import { useOutline } from 'components/Wizards/MultiStepBlogPostWizard/OutlineProvider'
import { useMutationWithErrorModal } from './useMutationWithErrorModal'

interface Props {
  onCancel?: () => void
}

export const useGenerateIntro = ({ onCancel }: Props) => {
  const { generateIntro } = useOutline()

  return useMutationWithErrorModal(generateIntro, { onCancel })
}
